import './bootstrap';
import $ from 'jquery';
require('select2');
global.$ = global.jQuery = $;